import Client from "../client";
import {
  SaveServiceEstimatePaymentMethodCommand,
  ServiceEstimatePaymentMethodRow
} from "@/api/project/estimate-payment-method-api";

export default class EstimatePaymentMethodApi {
  public constructor(private client: Client) {}

  public async find(id: string): Promise<ServiceEstimatePaymentMethodRow | null> {
    return await this.client.get("get_service_estimate_payment_method.php", {
      id
    });
  }

  public async all(): Promise<ServiceEstimatePaymentMethodRow[]> {
    const list = await this.client.get(
      "get_all_service_estimate_payment_method.php"
    );
    return Array.isArray(list) ? list : [];
  }

  public async save(command: SaveServiceEstimatePaymentMethodCommand) {
    const data = new FormData();
    if (command.id) {
      data.append("id", String(command.id));
    }
    data.append("name", command.name);
    await this.client.post("create_service_estimate_payment_method.php", data);
  }

  public async remove(id: number) {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_service_estimate_payment_method.php", d);
  }

  public async sort(ids: number[]) {
    const d = new FormData();
    ids.forEach((id, i) => {
      d.append(`ids[${i}]`, String(id));
    });
    await this.client.post("sort_service_estimate_payment_method.php", d);
  }
}
